/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ProviderUserState {

    CREATED = 'CREATED',

    INVITED = 'INVITED',

    ACTIVE = 'ACTIVE',

    INACTIVE = 'INACTIVE',

    REJECTED = 'REJECTED',

    EMAIL_ERROR = 'EMAIL_ERROR',

    DELETED = 'DELETED'
}

